export default __webpack_public_path__ + "static/media/gallery_07.620efe55.jpg";